/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForCloudstack extends models.ServiceAccountNativeDetailsBaseForCloud {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForCloudstack");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForCloudstack.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForCloudstack>): ServiceAccountNativeDetailsForCloudstack {
        let obj = Object.assign(new ServiceAccountNativeDetailsForCloudstack(), model);
        ServiceAccountNativeDetailsForCloudstack.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForCloudstack>): ServiceAccountNativeDetailsForCloudstack {
        if (!model) return null;
        return ServiceAccountNativeDetailsForCloudstack.newInstance(<ServiceAccountNativeDetailsForCloudstack> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForCloudstack) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForCloudstack.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForCloudstack): boolean {
        if (models.ServiceAccountNativeDetailsBaseForCloud.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForCloudstack.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.default_values) {
            models.SelfServiceDefaultValuesForCloudstack.fixupPrototype(this.default_values);
        }
    }

    /**
     * SelfService Default Values
     */
    default_values: models.SelfServiceDefaultValuesForCloudstack;

}
